module.exports = "/_next/static/media/423c4692b9ca839dbc599f963d532a4a.svg";